// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"881":"f203dc29","906":"ce4b2fa7"}[chunkId] + ".js";
};